import { AUTH_ENABLED } from "./config";

/* Per-request init the HTTP clients merge into their fetch calls. When auth is
 * enabled, send the identity-service session cookie (the in-app session is
 * cookie-based — see identitySession.ts). When disabled, no credentials — the
 * clients fall back to the static VITE_ANALYTICS_API_KEY Bearer for local/algo
 * envs.
 *
 * NOTE: the gateway may still require the static API key server-side even with
 * a cookie present (open question in the auth plan). This is additive — it adds
 * the cookie without removing the Bearer header — so neither path regresses. */
export function authFetchInit(): Pick<RequestInit, "credentials"> {
  return AUTH_ENABLED ? { credentials: "include" } : {};
}
